import React from 'react';
import { Form, Icon, Input, Button, Modal, Cascader } from 'antd';
import { connect } from 'react-redux';
import { startLogin } from '../../actions/auth';
//import {startSetEconomicModel} from '../../actions/globalState';
import { Redirect } from 'react-router-dom'
import { Alert } from 'antd';
const FormItem = Form.Item;

const hasErrors = (fieldsError) => {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export class LoginForm extends React.Component {
  state = {
    loading: false,
    visible: false,
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  handleOk = () => {
      this.setState({ loading: false, visible: false });
  }

  componentDidMount() {
    // To disabled submit button at the beginning.
    //this.props.form.validateFields();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    //console.log('handleSubmit', this.props.auth)
    this.props.form.validateFields((err, values) => {
      if (!err) {
        //console.log('Received values of form: ', values);
        this.props.startLogin(values);
        //this.props.startSetEconomicModel();
      } 
    });
  }
//state.auth.isLoggedin
  render() {
    const hasLoginError =  (!this.props.auth.isLoggedin  && this.props.auth.code !== undefined && this.props.auth.code !== 200)
    const hasLoginSession = this.props.auth.isLoggedin && this.props.auth.code === 200
    //console.log('hasLoginError', hasLoginError, 'this.props.auth.code', this.props.auth.code !== 200, 'this.props.auth', this.props.auth)
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const { visible, loading } = this.state;
    // Only show error after a field is touched.
    const userNameError = isFieldTouched('userName') && getFieldError('userName');
    const passwordError = isFieldTouched('password') && getFieldError('password');

    if (hasLoginSession) {
      return (
        <Redirect to="/economicmodeldashboard" />
      )
    }
    return (
      <div className="economic-model-login-form">
      
        <h1>Economic Model</h1>
        <p>Please enter username and password to log in</p>
        { hasLoginError && ( <Alert
          message="Incorrect username/password combination."
          type="error"/>) 
      }
        <Form layout="horizontal" onSubmit={this.handleSubmit}>

          <FormItem
            label="Username"
            colon={true}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 4 }}
            validateStatus={userNameError ? 'error' : ''}
            help={userNameError || ''}
            className="ant-row-flex ant-row-flex-center"
          >
            {getFieldDecorator('userName', {
              rules: [{ required: true, message: 'Please input your username!' }],
            })(
              <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
            )}
          </FormItem>
          <FormItem
            label="Password"
            colon={true}
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 4 }}
            validateStatus={passwordError ? 'error' : ''}
            help={passwordError || ''}
            className="ant-row-flex ant-row-flex-center"
          >
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
            })(
              <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
            )}
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              htmlType="submit"
              disabled={hasErrors(getFieldsError())}
            >
              Log in
            </Button>
          </FormItem>
        </Form>
        <Modal
          visible={visible}
          title="Economic Model"
          onOk={this.handleOk}
          onCancel={this.handleOk}
          footer={[
            <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>
              Close
            </Button>,
          ]}
        >
        <p>Incorrect username/password combination.</p>
        <p>If you have forgotten your login details, please contact Geografia on <a href="tel:0393299004">(03) 9329 9004</a> or email <a href="mailto:info@geografia.com.au">info@geografia.com.au</a>.</p>
        </Modal>
      </div>
    );
  }
}

const EconomicModelLoginForm = Form.create()(LoginForm);

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  startLogin: (values) => dispatch(startLogin(values)),
  //startSetEconomicModel: () => dispatch(startSetEconomicModel())
});

export default connect(mapStateToProps, mapDispatchToProps)(EconomicModelLoginForm);


// WEBPACK FOOTER //
// ./src/components/economicModel/LoginForm.js